import * as React from "react";
import Svg, { G, Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={13}
      height={13}
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <G fill="#4874FE">
        <Path d="M6.954 5.895a.454.454 0 00-.907 0v3.628a.453.453 0 00.907 0V5.895z" />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.5 0a6.5 6.5 0 100 13 6.5 6.5 0 000-13zM.907 6.5a5.593 5.593 0 1111.186 0 5.593 5.593 0 01-11.186 0z"
        />
        <Path d="M7.104 4.081a.605.605 0 11-1.21 0 .605.605 0 011.21 0z" />
      </G>
    </Svg>
  );
}

export default SvgComponent;
